import {
  GET_ROOM_STATUS_LIST,
  GET_ROOM_STATUS_LIST_FAILED,
  GET_ROOM_STATUS_LIST_SUCCESS,

  UPDATE_ROOM_STATUS_LIST,
  UPDATE_ROOM_STATUS_LIST_FAILED,
  UPDATE_ROOM_STATUS_LIST_SUCCESS,

  QUICK_UPDATE_ROOM_STATUS,
  QUICK_UPDATE_ROOM_STATUS_FAILED,
  QUICK_UPDATE_ROOM_STATUS_SUCCESS,
} from './actionTypes';

export const actionGetRoomStatusList = (payload) => ({
  payload,
  type: GET_ROOM_STATUS_LIST,
});

export const actionGetRoomStatusListSuccess = (payload) => ({
  payload,
  type: GET_ROOM_STATUS_LIST_SUCCESS,
});

export const actionGetRoomStatusListFailed = (payload) => ({
  payload,
  type: GET_ROOM_STATUS_LIST_FAILED,
});

export const actionUpdateLocation = (payload) => ({
  payload,
  type: UPDATE_ROOM_STATUS_LIST,
});

export const actionUpdateLocationSuccess = (payload) => ({
  payload,
  type: UPDATE_ROOM_STATUS_LIST_SUCCESS,
});

export const actionUpdateLocationFailed = (payload) => ({
  payload,
  type: UPDATE_ROOM_STATUS_LIST_FAILED,
});

export const actionQuickUpdateRoomStatus = (payload) => ({
  payload,
  type: QUICK_UPDATE_ROOM_STATUS,
});

export const actionQuickUpdateRoomStatusSuccess = (payload) => ({
  payload,
  type: QUICK_UPDATE_ROOM_STATUS_SUCCESS,
});

export const actionQuickUpdateRoomStatusFailed = (payload) => ({
  payload,
  type: QUICK_UPDATE_ROOM_STATUS_FAILED,
});
